<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>Support Filters</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" tappable>
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="none" mode="ios">
    <h6 class="ion-text-left ion-padding-start">Status</h6>
    @for (option of statusOptions; track option.value) {
      <ion-item mode="ios" lines="none">
        <ion-checkbox
          justify="space-between"
          mode="md"
          color="warning"
          [checked]="option.checked"
          (ionChange)="updateOption(option, $event)"
        >
          {{ option.label }}
        </ion-checkbox>
      </ion-item>
    }

    <h6 class="ion-text-left ion-padding-start">Assignment</h6>
    @for (option of assignmentOptions; track option.value) {
      <ion-item mode="ios" lines="none">
        <ion-checkbox
          justify="space-between"
          mode="md"
          color="warning"
          [checked]="option.checked"
          (ionChange)="updateOption(option, $event)"
        >
          {{ option.label }}
        </ion-checkbox>
      </ion-item>
    }

    <h6 class="ion-text-left ion-padding-start">User Type</h6>
    @for (option of userTypeOptions; track option.value) {
      <ion-item mode="ios" lines="none">
        <ion-checkbox
          justify="space-between"
          mode="md"
          color="warning"
          [checked]="option.checked"
          (ionChange)="updateOption(option, $event)"
        >
          {{ option.label }}
        </ion-checkbox>
      </ion-item>
    }

    <h6 class="ion-text-left ion-padding-start">Operational</h6>
    @for (option of slaOptions; track option.value) {
      <ion-item mode="ios" lines="none">
        <ion-checkbox
          justify="space-between"
          mode="md"
          color="warning"
          [checked]="option.checked"
          (ionChange)="updateOption(option, $event)"
        >
          {{ option.label }}
        </ion-checkbox>
      </ion-item>
    }
    <ion-item mode="ios" lines="none">
      <ion-checkbox
        justify="space-between"
        mode="md"
        color="warning"
        [checked]="starredOnly"
        (ionChange)="updateFlag('starredOnly', $event)"
      >
        Starred only
      </ion-checkbox>
    </ion-item>
    <ion-item mode="ios" lines="none">
      <ion-checkbox justify="space-between" mode="md" color="warning" [checked]="unreadOnly" (ionChange)="updateFlag('unreadOnly', $event)">
        Unread only
      </ion-checkbox>
    </ion-item>

    <h6 class="ion-text-left ion-padding-start">Sort</h6>
    <ion-radio-group mode="md" [(ngModel)]="sortMode">
      <ion-item mode="ios" (click)="sortMode = 'newest'">
        <ion-label>Newest first</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="newest" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="sortMode = 'oldest'">
        <ion-label>Oldest first</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="oldest" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="sortMode = 'sla'">
        <ion-label>Earliest SLA deadline</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="sla" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="sortMode = 'unread'">
        <ion-label>Unread first</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="unread" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>

<ion-footer mode="ios">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
      <ion-col sizeXl="7" sizeLg="7" sizeMd="10" sizeSm="12" sizeXs="12">
        <ion-row>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="applyFilters()">Apply</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clearFilters()">Clear</ion-button>
          </ion-col>
        </ion-row>
        <br />
      </ion-col>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
